<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title><h2>Sie haben einen Umfrageschritt abgeschlossen</h2></v-card-title>
      <v-card-text class="mb-6">Möchten Sie sich die Auswertung der verknüpften Umfrage anzeigen lassen?</v-card-text>
      <v-card-actions class="pr-6 pb-6">
        <v-btn id="leftButton" text @click.stop="cancel" color="gray_3">Nein</v-btn>
        <v-btn id="rightButton" elevation="0" @click.stop="agree" color="primary">Ja</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      options: {
        width: 400,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>